import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  list: [],
  item: null,
};

const zpCTypPrace = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_ZP_C_TYP_PRACE_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_ZP_C_TYP_PRACE_SUCCESS:
      return { ...state, isLoading: false, list: action.res.Data };

    case actionTypes.GET_ZP_C_TYP_PRACE_FAILURE:
      return _initState;

    case actionTypes.CHANGE_TYP_PRACE:
      return { ...state, item: action.data };

    default:
      return state;
  }
};

export default zpCTypPrace;
